import { useState } from "react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './login.css';
import '../common/style.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../http/authcontex";

export default function LoginComponent() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    function handleUsernameChange(event) {
        setUsername(event.target.value);
    }

    function handlePasswordChange(event) {
        setPassword(event.target.value);
    }

    function togglePasswordVisibility() {
        setShowPassword(!showPassword);
    }

    const navigate = useNavigate();
    const authContext = useAuth();

    async function handleLogin() {
        //console.log("username " + username + ", password " + password);
        // Check if username or password is empty
        if (!username || !password) {
            setErrorMessage('Username and password must not be empty.');
            setError(true);
            return;
        }

        // Proceed to login if fields are filled
        //authContext.login
        if (await authContext.login(username, password)) {
            navigate(`/dashboard`);
            //navigate(`/bank`)
            setError(false);
        } else {
            setErrorMessage('Unable to login. Please check your credentials.');
            setError(true);
        }
    }

    return (
        <div className="LoginComponent">
            <div className="container mt-5">
                <div className="row d-flex justify-content-center">
                    <div className="col-md-5 col-sm-6">
                        <div className="card px-5 py-2 shadow border-0">
                            <div className="text-center mb-4">
                                <img 
                                    src="jvdlogo.png" 
                                    alt="JVD Logo" 
                                    className="img-fluid" 
                                    style={{ maxWidth: '100px' }} 
                                />
                            </div>

                            {error && <div className="alert alert-danger">{errorMessage}</div>}
                            
                            <label className="row form-label m-0 mt-2">Email ID :</label>
                            <input 
                                placeholder='Email ID' 
                                className="form-control" 
                                value={username} 
                                onChange={handleUsernameChange} 
                                type="text" 
                            />

                            <label className="row form-label m-0 mt-2">Password :</label>
                            <div className="input-group">
                                <input 
                                    placeholder='Password' 
                                    className="form-control" 
                                    value={password} 
                                    onChange={handlePasswordChange} 
                                    type={showPassword ? "text" : "password"} 
                                />
                                <button className="btn btn-outline-secondary" type="button" onClick={togglePasswordVisibility}>
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                            
                            <div className="mt-4 mb-2">
                                <button className="form-control btn btn-primary" onClick={handleLogin}>Login</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
